












import { ErrorCode, ErrorSeverity, ThrowErrorFunction, isDownstreamErrorCode } from "~/modules/error";
import { HttpAdapter } from "~/backend/HttpAdapter/HttpAdapter";
import { HttpAdapterImpl } from "~/backend/HttpAdapter/HttpAdapterImpl";
import { AuthenticationMethod } from "~/backend/commons/authenticationMethods"
import { convertDateStringValuesToDate } from "~/utils/processHttpAdapterResponse";
import { throwFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";
import { ContextManager } from "~/modules/contextManager/ContextManager";

import { AuthenticationConfigResponse } from "../model/authenticationConfigResponse";
import { TokenExchangeRequestBody } from "../model/tokenExchangeRequestBody";
import { TokenResponseBody } from "../model/tokenResponseBody";

import { SsoSetupService }  from "./ssoSetup.serviceInterface";

export class SsoSetupServiceImpl implements SsoSetupService {
    private httpAdapter: HttpAdapter;

    readonly #throwError: ThrowErrorFunction;

    constructor(ctx: ContextManager) {
        this.httpAdapter = new HttpAdapterImpl(ctx);
        this.#throwError = throwFlexSdkError(ctx);
        this.httpAdapter.setIsEdgeSupported();
    }

    





    public async generateOauthTokens(tokenExchangeRequestBody: TokenExchangeRequestBody): Promise<TokenResponseBody> {
        const metadata = {
            module: "backend",
            severity: ErrorSeverity.Error,
            source: "ssoSetup.service.ts"
        };
        if (tokenExchangeRequestBody === null || tokenExchangeRequestBody === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter tokenExchangeRequestBody was null or undefined.");
        }

        let response;
        try {
            response = await this.httpAdapter.post<TokenResponseBody>(`https://services[region].twilio.com/v1/Flex/OAuth/Tokens`, undefined, tokenExchangeRequestBody);
        } catch (e) {
            if (isDownstreamErrorCode(e.code)) {
                const message = `SsoSetupService - ${e.message}`
                return this.#throwError(ErrorCode.DownstreamServiceError, metadata, message) as unknown as Promise<never>;
            }

            return Promise.reject(e)
        }
        const processedResponse = convertDateStringValuesToDate<TokenResponseBody>(response);
        return processedResponse;
    }

    









    public async getAuthenticationConfig(accountSid?: string, flexInstanceSid?: string, runtimeDomain?: string, sSOProfileSid?: string, appType?: 'SinglePageApp' | 'MobileApp'): Promise<AuthenticationConfigResponse> {
        const metadata = {
            module: "backend",
            severity: ErrorSeverity.Error,
            source: "ssoSetup.service.ts"
        };

        let response;
        try {
            response = await this.httpAdapter.get<AuthenticationConfigResponse>(`https://services[region].twilio.com/v1/Flex/Authentication/Config?AccountSid=${encodeURIComponent(String(accountSid))}&FlexInstanceSid=${encodeURIComponent(String(flexInstanceSid))}&RuntimeDomain=${encodeURIComponent(String(runtimeDomain))}&SSOProfileSid=${encodeURIComponent(String(sSOProfileSid))}&AppType=${encodeURIComponent(String(appType))}`, undefined);
        } catch (e) {
            if (isDownstreamErrorCode(e.code)) {
                const message = `SsoSetupService - ${e.message}`
                return this.#throwError(ErrorCode.DownstreamServiceError, metadata, message) as unknown as Promise<never>;
            }

            return Promise.reject(e)
        }
        const processedResponse = convertDateStringValuesToDate<AuthenticationConfigResponse>(response);
        return processedResponse;
    }
}

